import React from 'react';
import { Chip } from '@mui/material';
import {
  Error as ErrorIcon,
  HourglassEmpty as PendingIcon,
  Send as SendIcon,
  MarkEmailRead as DeliveredIcon,
  ReportProblem as BouncedIcon,
  ThumbDown as ComplainedIcon,
} from '@mui/icons-material';
import type { EmailLog } from '../../api/admin';

export function EmailStatusChip({ status }: { status: EmailLog['status'] }) {
  switch (status) {
    case 'delivered':
      return <Chip label="Delivered" color="success" size="small" icon={<DeliveredIcon />} />;
    case 'sent':
      return <Chip label="Sent" color="info" size="small" icon={<SendIcon />} />;
    case 'failed':
      return <Chip label="Failed" color="error" size="small" icon={<ErrorIcon />} />;
    case 'bounced':
      return <Chip label="Bounced" color="warning" size="small" icon={<BouncedIcon />} />;
    case 'complained':
      return <Chip label="Complained" color="error" size="small" icon={<ComplainedIcon />} />;
    case 'pending':
    default:
      return <Chip label="Pending" color="default" size="small" icon={<PendingIcon />} />;
  }
}
